const Demo={
    BLANK_LINK:"#!",
};

export default Demo;